import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly STORAGE_KEY = 'platformType';
  private readonly DEFAULT_LANG = 'pt-BR';

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang(this.DEFAULT_LANG);

    const saved = sessionStorage.getItem(this.STORAGE_KEY);
    this.translate.use(saved === 'dizimo' ? 'dizimo' : this.DEFAULT_LANG);
  }

  setLanguage(platformType: string): void {
    const lang = platformType === 'dizimo' ? 'dizimo' : this.DEFAULT_LANG;
    sessionStorage.setItem(this.STORAGE_KEY, platformType);
    this.translate.use(lang);
  }

  getLanguage(): string {
    return this.translate.currentLang || this.DEFAULT_LANG;
  }

  getPlatformType(): string {
    return sessionStorage.getItem(this.STORAGE_KEY) || 'recarga';
  }
}
